// src/components/layout/mobile_ProjectMenus.jsx

// 모바일 전용 메뉴 데이터
// (PC용 ProjectMenus와 구조 동일하게 동기화)
export const mobileProjectMenus = {
  materials: {
    title: "자재관리",
    base: (id) => `/project/${id}/materials`,
    baseClick: "materialboard",
    sections: [
      {
        title: "전체 게시판",
        items: [{ to: "materialboard", label: "전체 문서 목록", end: true }],
      },

      {
        title: "자재승인요청서",
        items: [
          { to: "list/ps", label: "자재승인요청서 목록" },
          { to: "plan/new", label: "자재승인요청서 작성" },
        ],
      },

      {
        title: "발주서",
        items: [
          { to: "list/po", label: "발주서 목록" },
          { to: "order/new", label: "발주서 작성" },
        ],
      },

      {
        title: "입고/출고",
        items: [
          { to: "list/gr", label: "입고 목록" },
          { to: "list/gi", label: "출고 목록" },
          { to: "gr/new", label: "입고서 작성" },
          { to: "gi/new", label: "출고서 작성" },
        ],
      },

      {
        title: "검측요청서",
        items: [
          { to: "list/qc", label: "검수 요청서 목록" },
          { to: "list/ck", label: "검수 CheckList 목록" },
          { to: "qc/new", label: "검수 요청서 작성" },
          { to: "ck/new", label: "검수 CheckList 작성" },
        ],
      },

      {
        title: "재고",
        items: [{ to: "stock", label: "재고 현황" }],
      },
    ],
  },

  fourd: {
    title: "4D 시뮬레이션",
    base: (id) => `/project/${id}/4d`,
    baseClick: "",
    sections: [
      {
        title: "4D 시뮬레이션",
        items: [
          {
            to: "",
            label: "4D 시뮬레이션 보기",
            end: true,
          },
          {
            to: "upload",
            label: "4D 시뮬레이션 업로드",
            end: true,
          },
        ],
      },
    ],
  },
  approval: {
    title: "전자결재",
    base: (id) => `/project/${id}/approval`,
    baseClick: "mydocs",
    sections: [
      {
        title: "결재 상신",
        items: [{ to: "request/new", label: "결재 문서 작성", end: true }],
      },
      {
        title: "결재 양식",
        items: [{ to: "type", label: "결재 양식 리스트" }],
      },
      {
        title: "문서함",
        items: [
          { to: "mydocs", label: "내 결재함" },
          { to: "docs", label: "전체 결재함" },
        ],
      },
    ],
  },
  const: {
    title: "시공관리",
    base: (id) => `/project/${id}/const`,
    baseClick: "daily",
    sections: [
      {
        title: "공사일보",
        items: [
          { to: "workdetails", label: "상세작업 입력" },
          { to: "daily", label: "공사일보" },
          { to: "userDefine", label: "사용자 정의" },
        ],
      },
      {
        title: "주/월간보고",
        items: [
          { to: "progress", label: "주/월간보고" },
          { to: "userTemplate", label: "사용자 지정 템플릿" },
        ],
      },
      {
        title: "시공사진",
        items: [
          { to: "photoboard", label: "사진대지" },
          { to: "photo", label: "시공사진", end: true },
        ],
      },
      {
        title: "작업지시/보고",
        items: [
          { to: "order", label: "작업지시서" },
          { to: "ordercomplete", label: "완료보고서", end: true },
        ],
      },
    ],
  },
  contract: {
    title: "계약·비용관리",
    base: (id) => `/project/${id}/contract`,
    baseClick: "info?construction_type=",
    sections: [
      {
        title: "계약 관리",
        items: [
          {
            to: { pathname: "info" },
            label: "시공(도급) 계약",
          },
          {
            to: { pathname: "sub" },
            label: "하도급 계약",
          },
        ],
      },
      {
        title: "기성 항목 관리",
        items: [
          { to: { pathname: "cost/list" }, label: "기성 등록·수정" },
          { to: { pathname: "cost/view" }, label: "기성 현황" },
        ],
      },
    ],
  },

  design: {
    title: "설계관리",
    base: (id) => `/project/${id}/design`,
    baseClick: "list/all",
    sections: [
      {
        title: "전체 게시판",
        items: [{ to: "list/all", label: "전체 문서 목록", end: true }],
      },
      {
        title: "설계변경 문서",
        items: [
          { to: "list/fcr", label: "요청 문서 목록" },
          { to: "list/fcn", label: "현장 통보 문서 목록" },
          { to: "fc/new", label: "요청 / 통보 문서 작성" },
        ],
      },
      {
        title: "설계사 통보 문서",
        items: [
          { to: "list/dcn", label: "설계 통보 문서 목록" },
          { to: "dcn/new", label: "설계 통보 문서 작성" },
        ],
      },
      {
        title: "설계도서 관리",
        items: [{ to: "detail", label: "도서 라이브러리" }],
      },
    ],
  },
  meeting: {
    title: "회의∙공지",
    base: (id) => `/project/${id}/meeting`,
    baseClick: "plan",
    sections: [
      {
        title: "회의/협업관리",
        items: [
          { to: "plan", label: "회의 캘린더", end: true },
          { to: "rooms", label: "회의실 관리", end: true },
        ],
      },
      {
        title: "일정 관리",
        items: [{ to: "schedule", label: "일정 캘린더", end: true }],
      },
      {
        title: "공지사항",
        items: [
          { to: "notice/list", label: "공지사항" },
          { to: "notice/new", label: "공지사항 작성", end: true },
        ],
      },
    ],
  },
  permit: {
    title: "인허가",
    base: (id) => `/project/${id}/permit`,
    baseClick: "list",
    sections: [
      {
        title: "인허가 조회",
        items: [
          { to: "new", label: "인허가 등록" },
          { to: "list", label: "인허가 현황" },
          { to: "schedule", label: "인허가 일정", end: true },
        ],
      },
    ],
  },
  process: {
    title: "공정관리",
    base: (id) => `/project/${id}/process`,
    baseClick: "upload",
    sections: [
      {
        title: "공정 파일 업로드",
        items: [
          { to: "upload", label: "공정 파일 업로드" },
          { to: "milestone", label: "마일스톤 관리", end: true },
        ],
      },
      {
        title: "공정 조회",
        items: [
          { to: "construction", label: "공정표" },
          { to: "progress", label: "공정 진도율" },
          { to: "mta", label: "MTA 분석" },
        ],
      },
    ],
  },
  quality: {
    title: "품질관리",
    base: (id) => `/project/${id}/quality`,
    baseClick: "list/all",
    sections: [
      {
        title: "전체 게시판",
        items: [{ to: "list/all", label: "전체 문서 목록", end: true }],
      },
      {
        title: "검측요청서 (MI)",
        items: [
          { to: "list/incoming", label: "자재검수 목록" },
          { to: "incoming/new", label: "자재검수 작성" },
        ],
      },
      {
        title: "검측 CheckList (PC)",
        items: [
          { to: "list/process", label: "문서 목록" },
          { to: "process/new", label: "검측 CheckList(PC) 작성" },
        ],
      },
      {
        title: "NCR / CAR",
        items: [
          { to: "list/ncr", label: "NCR / CAR 목록" },
          { to: "ncr/new", label: "NCR 작성" },
          { to: "car/new", label: "CAR 작성" },
        ],
      },
    ],
  },
  safety: {
    title: "안전관리",
    base: (id) => `/project/${id}/safety`,
    baseClick: "calendar",
    sections: [
      {
        title: "안전관리 계획서",
        items: [
          { to: "board/report", label: "안전관리 계획서 목록" },
          { to: "report/new", label: "안전관리 계획서 등록" },
        ],
      },
      {
        title: "안전 점검 일정 및 CCTV",
        items: [
          { to: "calendar", label: "안전 점검 일정" },
          { to: "live", label: "CCTV(실시간 안전관리)", end: true },
        ],
      },

      {
        title: "SCAR",
        items: [
          { to: "board/scar", label: "SCAR 목록" },
          { to: "scar/new", label: "SCAR 작성" },
        ],
      },

      {
        title: "점검 예정",
        items: [
          { to: "board/check", label: "점검 예정 목록" },
          { to: "check/new", label: "점검 예정 작성" },
        ],
      },

      {
        title: "위험성 평가서",
        items: [
          { to: "board/riskcheck", label: "위험성 평가서 목록" },
          { to: "riskcheck/new", label: "위험성 평가서 작성" },
        ],
      },

      {
        title: "사고 이력",
        items: [
          { to: "board/incident", label: "사고 이력 목록" },
          { to: "incident/new", label: "사고 이력 작성" },
        ],
      },
    ],
  },

  pcmodule: {
    title: "PCModule",
    base: (id) => `/project/${id}/pcmodule`,
    baseClick: "",
    sections: [
      {
        title: "PCModule 관리",
        items: [
          {
            to: "prod",
            label: "생산 관리",
            end: true,
          },
          {
            to: "matl",
            label: "자재 관리",
            end: true,
          },
          {
            to: "stock",
            label: "물류 관리",
            end: true,
          },
          {
            to: "quality",
            label: "품질 관리",
            end: true,
          },
        ],
      },
    ],
  },
  overview: {
    title: "사업개요",
    base: (id) => `/project/${id}/overview`,
    baseClick: "view",
    sections: [
      {
        title: "사업개요",
        items: [
          {
            to: "view",
            label: "사업개요 조회",
          },
        ],
      },
    ],
  },
  docs: {
    title: "자료실",
    base: (id) => `/project/${id}/docs`,
    baseClick: "data",
    sections: [
      {
        title: "자료실",
        items: [
          {
            to: "data",
            label: "자료실 조회",
          },
        ],
      },
    ],
  },
  ai: {
    title: "P6ix AI",
    base: (id) => `/project/${id}/ai`,
    baseClick: "dashboard",
    sections: [
      {
        title: "AI 대시보드",
        items: [
          { to: "dashboard", label: "종합 인사이트", end: true },
        ],
      },
      {
        title: "AI 어시스턴트",
        items: [
          { to: "chat", label: "P6ix 챗봇" },
          { to: "chat/history", label: "대화 기록" },
        ],
      },
      {
        title: "문서 인텔리전스",
        items: [
          { to: "document/summary", label: "문서 자동 요약" },
          { to: "document/search", label: "스마트 문서 검색" },
        ],
      },
      {
        title: "비전 AI",
        items: [
          { to: "vision/safety", label: "안전 이미지 분석" },
          { to: "vision/quality", label: "품질 결함 탐지" },
        ],
      },
      {
        title: "예측 인사이트",
        items: [
          { to: "predict/schedule", label: "공정 지연 예측" },
          { to: "predict/material", label: "자재 수요 예측" },
        ],
      },
      {
        title: "AI 자동화",
        items: [
          { to: "automation/report", label: "보고서 자동 생성" },
          { to: "automation/risk", label: "위험성 평가 AI" },
        ],
      },
    ],
  },
};
